import React from 'react';
import { Button, Card, Col } from 'react-bootstrap';

const Service = (props) => {
    const { name, description, img } = props.service;
    return (
        <Col>
            {/*creating cards*/}
            <Card className="rounded rounded-3 border shadow">
                <Card.Img variant="top" src={img} style={{ height: "300px" }} />
                <Card.Body>
                    <Card.Title className="fs-2 fw-bold">{name}</Card.Title>
                    <Card.Text>
                        {description}
                    </Card.Text>
                </Card.Body>
                <Button className="px-4 py-2 fw-bold rounded-pill w-50 mx-auto mb-4" variant="success">Learn More</Button>
            </Card>
        </Col>
    );
};

export default Service;